import { zodResolver } from "@hookform/resolvers/zod"
import { MdArrowBack } from "react-icons/md"
import { Button, Col, Container, Form, InputGroup, Row } from "react-bootstrap"
import { useForm } from "react-hook-form"
import { useNavigate, useLocation } from "react-router-dom"
import { z } from "zod"
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from '../Utils/assets/img/pugcrm_logo_description.png';
import { useEffect, useState } from "react"
import useLocalStorageState from "use-local-storage-state"
import { PostRequest } from "../Utils/hooks/ApiHandler"
import favicon from '../Utils/assets/img/pugcrm_logo1.png';
import { toast } from "sonner"
import { baseURL } from "../Utils/constants/constant"

const forgotPassSchema = z.object({
    email: z.string().email(),
    otp: z.string().min(1, "Otp is Required"),
    password: z.string().min(6, "Password Must be of 6 characters"),
    confirmPass: z.string().min(6, "Password Must be of 6 characters")
}).refine((data) => data.password === data.confirmPass, {
    message: "Passwords do not match",
    path: ["confirmPass"],
});
export const ForgotPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();


    const [showPassword, setShowPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);
    // user id from sent otp response
    const [user_id, setUserId] = useState()
    // when otp sent successfully 
    const [isOtpSent, setIsOtpSent] = useState(false)
    // is otp validated successfully
    const [isOtpValid, setIsOtpValid] = useState(false)
    const [pointerEvent, setPointerEvent] = useState(false); // to make email input un-editable once otp sent
    const [hiddenOtpSection, setHiddenOtpSection] = useState(false); //once otp validate make it hidden 
    // checking is already authenticated
    const [customer] = useLocalStorageState('customer');
    const [lastPath] = useLocalStorageState('lastPath');
    useEffect(() => {
        if (customer && customer?.user_login === true && customer?.customer_status === "Active") {
            navigate(lastPath, { replace: true });
        }
        return () => { }
    }, [lastPath]);


    // form methods destructuring
    const { handleSubmit, register, reset, watch, formState: { errors, isValid, } } = useForm({
        resolver: zodResolver(forgotPassSchema)
    })

    // sendotp handler
    const handleSendOtp = async () => {
        const formEmail = watch("email")
        if (!formEmail) return
        const res = await PostRequest("/auth/Forgetpassowrd/sendOtp", { email: formEmail }, false, {}, {})
        if (res.success === false) {
            toast.warning(res.msg);
            return;
        }
        if (res.status === "fail") {
            toast.warning(res.message);
            return;
        }
        setPointerEvent(true)
        setUserId(res.data[0]['id'])
        setIsOtpSent(true)
        toast.success(res.message);
    }

    // validate otp 
    const handleValidate = async () => {
        const otp = watch("otp");
        if (!otp) return;
        const res = await PostRequest('auth/Forgetpassowrd/validateOtp', { user_id: user_id, otp: otp }, false, {}, {})
        if (res.success === false) {
            toast.warning(res.msg);
            return;
        }
        if (res.status === "fail") {
            toast.warning(res.message);
            return;
        }
        setHiddenOtpSection(true)
        setIsOtpValid(true);
        toast.success(res.message);
    }
    const handleFormSubmit = async () => {
        const pass = watch("password");
        const confPass = watch("confirmPass");
        const email = watch('email')
        if (!pass && !confPass && !email) return

        const res = await PostRequest("auth/Forgetpassowrd/updatePassword", { user_id: user_id, email: email, password: pass, conf_password: confPass }, false, {}, {})
        if (res.success === false) {
            toast.warning(res.msg);
            return;
        }
        if (res.status === "fail") {
            toast.warning(res.message);
            return;
        }
        reset();
        setPointerEvent(false)
        setHiddenOtpSection(false)
        navigate('/login');
        toast.success(res.message)
    }
    return (

        <Container fluid className="  p-0" style={{ fontFamily: "'Poppins', sans-serif" }}>
            <Row className="overflow-hidden bg-white w-100 pe-2 m-0 mainDivs" style={{ height: 'calc(100vh - 0rem)', padding: '30px 0px' }}>

                <div className="BaseBox col-md-8 ps-8">
                    {/* <div className="logoImgDivs" style={Styles.logoImgDivs}>
                        
                    </div> */}
                    <div>
                        <div className="BaseBox-inner">

                            <h3 className="StyledBaseText" ><span className="StyledBaseText" >India's No 1</span> Choice for Smarter Selling Simplest and Secure CRM Technology.</h3>

                        </div>
                        <div className="BaseBox-second">
                            <div className="BaseBox-second-inner">
                                <div className="BaseBox-second-inner-icon">
                                    <i className="fa fa-star"></i>
                                </div>
                                <h6 className="StyledBaseText">Automated Lead <span style={{ fontSize: '1rem', lineHeight: 1.5 }}>Distribution</span></h6>
                            </div>
                            <div className="BaseBox-second-inner">
                                <div className="BaseBox-second-inner-icon">
                                    <i className="fa fa-user-tie"></i>
                                </div>
                                <h6 className="StyledBaseText">Sales Analytics & <span style={{ fontSize: '1rem', lineHeight: 1.5 }}>Forcasting</span></h6></div>
                            <div className="BaseBox-second-inner">
                                <div className="BaseBox-second-inner-icon">
                                    <i className="fa fa-briefcase"></i>
                                </div>
                                <h6 className="StyledBaseText">Social Media <span style={{ fontSize: '1rem', lineHeight: 1.5 }}>Integration</span></h6>
                            </div>
                            <div className="BaseBox-second-inner">
                                <div className="BaseBox-second-inner-icon">
                                    <i className="fa fa-earth-asia"></i>
                                </div>
                                <h6 className="StyledBaseText">Analytics <span style={{ fontSize: '1rem', lineHeight: 1.5 }}>Dashboard</span></h6>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Right Panel - Registration Form */}
                <Col md={4} className="py-0 h-100 col-md-4 pe-4 p-0">
                    <div className="formDiv w-100 h-100 py-5 px-3">
                        <div className='innerFormDiv w-100'>
                            <div className="text-start ps-3 mb-4">
                                <img
                                    src={favicon}
                                    alt="Logo"
                                    className='favicon'
                                />

                                <p className="fw-bold bigHeading mt-5" style={{ color: 'black', fontSize: 28, lineHeight: 1.3 }}>Forget Password</p>
                                <p className="smallHeading mt-3" style={{ fontSize: 14, marginTop: 14, fontWeight: 400, letterSpacing: 0 }}>Enter your registered email id to reset password</p>

                            </div>

                            <Form onSubmit={handleSubmit(handleFormSubmit)} style={{ textAlign: 'justify', paddingLeft: "20px", paddingRight: "20px" }} className="form-container">

                                {/* email address */}
                                <Form.Group className="mb-3  d-flex flex-column focus-z-index position-relative" controlId="formEmail">
                                    <Form.Label>Email Address</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            style={{ pointerEvents: (pointerEvent ? 'none' : '') }}
                                            type="email"
                                            {...register("email", {
                                                required: true
                                            })}
                                            placeholder="Email Address"
                                        />
                                    </InputGroup>
                                    {errors.email && <p className='text-danger mt-1'>{errors.email.message}</p>}
                                    <div className="d-flex justify-content-between flex-row-reverse mt-2">
                                        <Button type="button" className="mt-2 btn btn-default" style={{ fontSize: '12px', opacity: isOtpValid ? 0 : 1 }} onClick={handleSendOtp} disabled={isOtpSent} >Send Otp</Button>
                                        <a onClick={() => navigate('/login')} className="mt-2" style={{ fontSize: '14px', cursor: "pointer" }}> <MdArrowBack /> <span style={{ textDecorationLine: "underline" }}>Back To Login</span> </a>
                                    </div>
                                </Form.Group>

                                {/* enter otp */}
                                {/* an api would be send and based on the response make the password fields visible */}
                                {
                                    watch("email")?.length > 0 && isOtpSent && !isOtpValid &&
                                    <Form.Group className="mb-3 mt-3 d-flex flex-column focus-z-index position-relative" controlId="formEmail" style={{ display: 'block' }}>
                                        <Form.Label>Enter Otp</Form.Label>
                                        <InputGroup className="w-50">
                                            <Form.Control
                                                type="text"
                                                {...register("otp", {
                                                    required: true
                                                })}
                                                placeholder="Enter Otp"
                                            />
                                        </InputGroup>
                                        {errors.otp && <p className='text-danger mt-1'>{errors.otp.message}</p>}
                                        <Button variant="primary" type="button" className="mt-2" style={{ fontSize: '12px' }} onClick={handleValidate} >Validate OTP</Button>
                                    </Form.Group>
                                }

                                {
                                    watch("otp")?.length > 0 && watch("email")?.length > 0 && isOtpValid &&
                                    <>
                                        <div className="row">
                                            <Form.Group  className="mb-3  d-flex flex-column focus-z-index position-relative col-md-6" controlId="formPassword">
                                                <Form.Label style={{marginLeft:".8rem"}}>Enter Password</Form.Label>
                                                <InputGroup >
                                                    <Form.Control
                                                        type={showPassword ? "text" : "password"}
                                                        {...register("password", {
                                                            required: true
                                                        })}
                                                        placeholder="Enter Password"
                                                    />
                                                    <span
                                                        onClick={() => setShowPassword((prev) => !prev)}
                                                        style={{
                                                            position: "absolute",
                                                            right: "4%",
                                                            top: "10%",
                                                            zIndex: 6,
                                                            padding: "2px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </span>
                                                </InputGroup>
                                                {errors.otp && <p className='text-danger mt-1'>{errors.password.message}</p>}
                                            </Form.Group>
                                            <Form.Group  className="mb-3  d-flex flex-column focus-z-index position-relative col-md-6" controlId="formConfirmPassword">
                                                <Form.Label style={{marginLeft:".8rem"}}>Confirm Password</Form.Label>
                                                <InputGroup >
                                                    <Form.Control
                                                        type={showConfPassword ? "text" : "password"}
                                                        {...register("confirmPass", {
                                                            required: true
                                                        })} placeholder="Confirm Password"
                                                    />
                                                    <span
                                                        onClick={() => setShowConfPassword((prev) => !prev)}
                                                        style={{
                                                            position: "absolute",
                                                            right: "4%",
                                                            top: "10%",
                                                            zIndex: 6,
                                                            padding: "2px",
                                                            cursor: "pointer",
                                                        }}
                                                    > {showConfPassword ? <FaEyeSlash /> : <FaEye />} </span>
                                                </InputGroup>
                                                {errors.otp && <p className='text-danger mt-1'>{errors.confirmPass.message}</p>}
                                            </Form.Group>
                                            {/* password must be checked within the handle function first and then execute teh api call */}
                                            <Button variant="primary" type="submit" className="w-100 py-2 fw-bold" disabled={!isValid}>
                                                Change Password
                                            </Button>
                                        </div>
                                    </>
                                }
                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>

    )
}